<template>
  <Page :title="convertLanage('责任人身份信息')">
    <UserInfo :value="formData" ref="userRef" :cert-type="enterpriseMarkup.corporationCertType" :cert-format="certFormat" :customer="true" />
    <template #slot-operation>
      <van-button class="page-rnr-main-btn-before lastStep" round @click="handleToBefore">{{ convertLanage('上一步') }}</van-button>
      <van-button type="primary" class="page-rnr-main-btn-next" round color="linear-gradient(120deg, #000 0%, #000 97%)" @click="handleToNext">{{ convertLanage('下一步') }}</van-button>
    </template>
  </Page>
</template>

<script>
import { mapGetters } from 'vuex'
import { SET_ENTERPRISE_OWNER, SET_OCR_PIC } from '@/store/modules/markup'
import Page from '@/components/Page'
import UserInfo from '@/components/UserInfo'
import { convertLanage } from '@/utils/lanage'

export default {
  name: 'MarkupEnterpriseUser',
  components: { Page, UserInfo },
  data() {
    return {
      formData: {
        certAddress: '',
        certExpirationDate: '',
        certNumber: '',
        certType: 'IDCARD',
        contactAddress: '',
        fullName: '',
        gender: ''
      },
      idCardType: '',
      certFormat: ''
    }
  },
  computed: {
    ...mapGetters(['enterpriseMarkup'])
  },
  activated() {
    const query = this.$route.query
    if (query.idCardType) {
      this.idCardType = query.idCardType
      this.certFormat = query.certFormat
    }
  },
  methods: {
    /**
     * 简繁体语言转换
     */
    convertLanage(strs) {
      return convertLanage(strs)
    },
    /**
     * 跳转到上一页
     */
    handleToBefore() {
      // 回退到上个页面
      this.$router.back()
    },

    handleToNext() {
      // 开始校验
      try {
        const formData = this.$refs.userRef.validate()
        // 将值塞到缓存中
        this.$store.commit(
          `markup/${SET_ENTERPRISE_OWNER}`,
          Object.keys(formData).reduce((memo, key) => {
            if (key === 'fullName') {
              memo['corporationName'] = formData[key]
            } else {
              const alias = `corporation${key.slice(0, 1).toUpperCase() + key.slice(1)}`
              memo[alias] = formData[key]
            }
            return memo
          }, {})
        )
        // 将当前选择的证件信息放到store中
        this.$store.commit(`markup/${SET_OCR_PIC}`, formData.ocrPic)
        // 开始跳转页面
        this.$router.push({ name: formData.certType === 'IDCARD' ? 'MarkupEnterpriseIdcard' : 'MarkupEnterprisePaper' })
      } catch (error) {
        console.error(error)
      }
    }
  }
}
</script>

<style lang="scss">
.page-rnr-main-fixed-btn-group {
  display: flex;
  justify-content: space-between;
  .page-rnr-main-btn-before {
    color: #242424 !important;
    flex: 1;
    height: 96px;
  }
  .page-rnr-main-btn-next {
    flex: 2;
    margin-left: 40px;
    height: 96px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/markup/enterprise/user.vue